import {Component, effect, ElementRef, EventEmitter, Input, OnInit, Output, signal, ViewChild} from '@angular/core';
import { HttpClient } from "@angular/common/http";
import {NotificationService} from "../../services/notification.service";
import {SharedModule} from "../../shared/modules/shared-module.module";

@Component({
    selector: 'flowchart-image-form',
    imports:[SharedModule],
    templateUrl: './flowchart-image-form.component.html'
})
export class FlowchartImageFormComponent implements OnInit {

    @Input() flowchart: any;
    @Input() component: any;
    @Input() show_hints: boolean;
    @Input() dialog: boolean;

    @Output() save_event = new EventEmitter();
    @Output() close_event = new EventEmitter();

    @ViewChild('imageUpload', {static: true}) fileUpload: ElementRef<HTMLInputElement>;
    @ViewChild('selectedImage') selectedImage: ElementRef;


    hint: string;
    showing_hints: any;
    component_data: any;
    _images = signal([]);
    ratio: number = 1;

    private _componentDataSrc = signal("")
    constructor(private notification: NotificationService,
                private http: HttpClient) {
        this.http.get("/api/get_icon_list").subscribe((images: any) => {
            this.images = images;
        });

        effect(() => {
            this.component_data.src = this._componentDataSrc();
        });
    }

    get images(): any {
        return this._images();
    }

    get componentDataSrc(): string {
        return this._componentDataSrc();
    }

    set images(value: any) {
        this._images.set(value);
    }

    set componentDataSrc(value: string) {
      this._componentDataSrc.set(value);
    }

    ngOnInit() {
        this.component_data = this.component.data;
        if (!this.component_data.width) {
            this.component_data.width = 200;
        }
    }

    change(obj) {
    }

    processFile() {
        const files = this.fileUpload.nativeElement.files;
        if (!files || files.length < 1) {
            return;
        }
        const file = files[0];

        const formData: FormData = new FormData();
        formData.append('file', file, file.name);
        this.notification.openInfo('Uploading image');

        this.http.post('/api/BlobData', formData).subscribe((response: { file_name: string }) => {
            this.notification.openSuccess('Image uploaded successfully.');
            this.componentDataSrc = '/admin/myfiles/download' + response.file_name
        }, error => {
            console.error('Error uploading collector data', error);
            this.notification.openError('An error occurred while collecting the file.');
        });
    };

    getNatural(direction) {
        let img = this.selectedImage.nativeElement;
        this.ratio = img.naturalWidth / img.naturalHeight;
        if (!this.component_data.constrain_proportions) {
            return;
        }
        if (direction === 'width') {
            this.component_data.height = img.width * this.ratio;
        } else {
            this.component_data.width = img.height * this.ratio;
        }
    }

    save() {
        if (this.component_data.constrain_proportions) {
            this.getNatural('width')
        }
        this.save_event.emit(this.component_data);
    }

    close(): void {
        this.close_event.emit();
    }
}
